import { api } from './api'
import type { TeamMember, TeamListResponse, CreateTeamMemberBody } from '@/types/team'

export const teamApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listTeam: builder.query<TeamListResponse, void>({
      query: () => '/team',
      providesTags: [{ type: 'Team', id: 'LIST' }],
    }),

    getTeamMember: builder.query<{ data: TeamMember }, string>({
      query: (id) => `/team/${id}`,
      providesTags: (result) =>
        result ? [{ type: 'Team', id: result.data.id }] : [],
    }),

    createTeamMember: builder.mutation<{ data: TeamMember }, CreateTeamMemberBody>({
      query: (body) => ({ url: '/team', method: 'POST', body }),
      invalidatesTags: [{ type: 'Team', id: 'LIST' }],
    }),

    updateTeamMember: builder.mutation<{ data: TeamMember }, { id: string } & Partial<CreateTeamMemberBody>>({
      query: ({ id, ...body }) => ({ url: `/team/${id}`, method: 'PATCH', body }),
      invalidatesTags: (result) =>
        result
          ? [{ type: 'Team', id: 'LIST' }, { type: 'Team', id: result.data.id }]
          : [{ type: 'Team', id: 'LIST' }],
    }),

    deleteTeamMember: builder.mutation<void, string>({
      query: (id) => ({ url: `/team/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Team', id: 'LIST' }],
    }),
  }),
})

export const {
  useListTeamQuery,
  useGetTeamMemberQuery,
  useCreateTeamMemberMutation,
  useUpdateTeamMemberMutation,
  useDeleteTeamMemberMutation,
} = teamApi
